import useTicketStatsQuery from '~/hooks/services/servicenow/queries/useTicketStatsQuery'

import { FcAlarmClock } from 'react-icons/fc'
import { useNavigate } from 'react-router'

import { Tile, TileHeader } from '../Tile'

const AwaitingActionTicketsTile = () => {
  const navigate = useNavigate()
  const { data: ticketStats, isLoading } = useTicketStatsQuery()

  return (
    <Tile onMouseDown={() => navigate('/tickets?state=awaiting_action')}>
      <TileHeader loading={isLoading}>
        <TileHeader.Title>{ticketStats?.awaiting ?? 0}</TileHeader.Title>
        <TileHeader.Subtitle>Awaiting Action</TileHeader.Subtitle>
        <TileHeader.Item>
          <FcAlarmClock className="h-10 w-10" />
        </TileHeader.Item>
      </TileHeader>
    </Tile>
  )
}

export default AwaitingActionTicketsTile
